import { $_app_server } from '@/_helpers'

export const pagesService = {
  //admin actions
  savePage,
  delPage,

  //anonimus actions
  loadPagesList,
  get,
  loadTopNav
}

//admin actions
function savePage (page) {
  return $_app_server.post('admin/page/save',page).then(response => response.data)
}

function delPage(id) {
  return $_app_server.delete("admin/page/del/" + id)
}

//anonimus actions
function loadPagesList () {
  return $_app_server.get('page/list').then(response => response.data)
}

function get (alias) {
  return $_app_server.get('page/'+alias).then(response => response.data)
}

function loadTopNav () {
  return $_app_server.get('page/listnav').then(response => response.data)
}